import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from "react";
import { Link, useNavigate } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";
import { loginRequest } from "../../../authConfig";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { addCandidates } from "../../../store/actions/Candidates/candidateActions";
import { debounce } from "../../../utils/debounce";
import { get, post } from "../../../services/api";
import swal from "sweetalert";

const AddCandidate = forwardRef((props, ref) => {
  const { instance, accounts } = useMsal();
  const [query, setQuery] = useState(""); // User's input
  const [results, setResults] = useState([]); // API results
  const [sourceList, setSourceList] = useState([]);
  const [statusList, setStatusList]= useState([]);

  const handleSuggestionClick = async (suggestion) => {
    const apiData = await fetch(
      `https://api.getaddress.io/${suggestion.url}?api-key=pdSw7G1TEk6kghR1DNzddQ41182&all=true`
    );
    const result = await apiData.json();
    // Destructure the API response
    const {
      line_1: addressLine1 = "",
      line_2: addressLine2 = "",
      town_or_city: town = "",
      county = "",
      country = "",
      postcode: postCode = "",
      region = "",
    } = result;

    // Update the form data with the new address details
    setFormData((prevFormData) => ({
      ...prevFormData,
      addressLine1,
      addressLine2,
      town,
      county,
      country,
      postCode,
      region,
    }));
    isCandidateAlreadyRegistered(postCode)
    // setFormData({ ...formData, [field]: value });
    setResults([]); // Clear suggestions after selection
  };

  useEffect(() => {
    if (props?.candidateSources) {
      setSourceList(props?.candidateSources?.map((itm) => itm.value));
    }

    if(props?.candidateStatus){
      setStatusList(props?.candidateStatus?.map((itm) => itm.value));
    }
  }, [props?.candidateSources, props?.candidateStatus]);

  const fetchData = async (searchTerm) => {
    const apiData = await fetch(
      `https://api.getaddress.io/autocomplete/${searchTerm}?api-key=pdSw7G1TEk6kghR1DNzddQ41182&all=true`
    );
    const result = await apiData.json();
    setResults(result.suggestions);
    console.log(results);
  };

  // Handle input changes
  const handlePostCodeQueryChange = (inputQuery) => {
    setQuery(inputQuery); // Update input state
    debounce(fetchData(inputQuery)); // Call the debounced function
  };

  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    title: "",
    firstName: "",
    lastName: "",
    knownAs: "",
    home: "",
    addressLine1: "",
    addressLine2: "",
    town: "",
    county: "",
    country: "",
    postCode: "",
    region: "",
    phone: "",
    phoneNumber: "",
    email: "",
    office: "",
    sector: "",
    personId: "",
    consultant: `${props?.loggedInUser?.firstName} ${props?.loggedInUser?.lastName}`,
    regDate: new Date(),
    source: "",
    recordUpdated: null,
    statusDate: null,
    status: "PRE-REG",
  });

  const resetForm = () => {
    setFormData({
      title: "",
      firstName: "",
      lastName: "",
      knownAs: "",
      home: "",
      addressLine1: "",
      addressLine2: "",
      town: "",
      county: "",
      country: "",
      postCode: "",
      region: "",
      phone: "",
      phoneNumber: "",
      email: "",
      office: "",
      sector: "",
      personId: "",
      consultant: `${props?.loggedInUser?.firstName} ${props?.loggedInUser?.lastName}`,
      regDate: new Date(),
      source: "",
      recordUpdated: null,
      statusDate: null,
      status: "PRE-REG",
    });
    setErrors({});
  };

  const [errors, setErrors] = useState({});
  const [addEmploye, setAddEmploye] = useState(false);

  useEffect(() => {
    if (!formData?.personId) {
      setPersonId();
    }
  }, []);

  const setPersonId = async () => {
    const personId = await get(
      "/api/sequence/candidate-person-id",
      props.token
    );
    setFormData({ ...formData, personId: personId.value });
  };

  useImperativeHandle(ref, () => ({
    showEmployeModal() {
      if (!formData?.personId) {
        setPersonId();
      }
      setAddEmploye(true);
    },
  }));

  const nav = useNavigate();

  const validate = () => {
    const newErrors = {};

    // Required fields
    const requiredFields = [
      "title",
      "firstName",
      "lastName",
      "postCode",
      "town",
      "country",
      "email",
      "phone",
      "phoneNumber",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field].trim()) {
        newErrors[field] = `${field.replace(/([A-Z])/g, " $1")} is required.`;
      }
    });

    // Email validation
    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email must be valid.";
    }

    // Phone and Phone Number validation
    if (!formData.phone) {
      newErrors.phone = "Phone type is required.";
    }
    if (
      formData.phoneNumber && 
      !/^(?:\+44|0)\d{10}$/.test(formData.phoneNumber)
    ) {
      newErrors.phoneNumber = "Phone Number must be a valid UK mobile number.";
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.error("Please fill all the required fields.");
    }
    return Object.keys(newErrors).length === 0;
  };
  useEffect(() => {
    if (formData.firstName && formData.lastName && formData.email) {
      isCandidateAlreadyRegistered();
    }
  }, [formData.firstName, formData.lastName, formData.email])
  const handleInputChange = (field, value) => {
    if (field === "postCode") {
      handlePostCodeQueryChange(value);
    }
    if (field === "phoneNumber") {
      value = value.replace(/\s/g, '');
    }
    setFormData({ ...formData, [field]: value });
    setErrors({ ...errors, [field]: "" }); 
  };

  const isCandidateAlreadyRegistered = async () => {
    const firstName = formData.firstName;
    const lastName = formData.lastName;
    const email = formData.email;
    
    if (firstName && lastName && email) {
      const res = await post(
        "/api/candidate/search",
        {
          search: [
            { idx: 0, field: "firstName", value: firstName },
            { idx: 1, field: "lastName", value: lastName },
            { idx: 2, field: "email", value: email },
          ],
          orsearch: [],
        },
        props.token
      );
      
      if(res?.data?.length > 0) {
        // Set error in the form instead of showing a confirmation dialog
        setErrors(prev => ({
          ...prev,
          duplicateCandidate: `A candidate with name ${firstName} ${lastName} and email ${email} already exists.`
        }));
        return true; // Return true if duplicate found
      } else {
        // Clear the duplicate error if it was previously set
        setErrors(prev => {
          const newErrors = {...prev};
          delete newErrors.duplicateCandidate;
          return newErrors;
        });
        return false; // Return false if no duplicate found
      }
    }
    return false;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // First check if candidate already exists
    const isDuplicate = await isCandidateAlreadyRegistered();
    
    if (isDuplicate) {
      // Show toast notification for duplicate candidate
      toast.error(errors.duplicateCandidate);
      return; // Prevent form submission
    }
    
    if (validate()) {
      const payrollNo = await get(
        "/api/sequence/candidate-payroll-no",
        props.token
      );

      const payload = {
        title: formData?.title,
        firstName: formData?.firstName,
        lastName: formData?.lastName,
        knownAs: formData?.knownAs,
        address: [
          {
            addressType: "HOME",
            isDefault: true,
            addressLine1: formData?.addressLine1,
            addressLine2: formData?.addressLine2,
            addressLine3: "",
            town: formData?.town,
            county: formData?.county,
            country: formData?.country,
            postcode: formData?.postCode,
            region: formData?.region,
          },
        ],
        contact: {
          phoneType: formData?.phone,
          phoneNumber: formData?.phoneNumber,
        },
        email: formData?.email?.toLowerCase(),
        website: "",
        business: "Rapid Resourcing Ltd",
        office: "Liverpool",
        sector: formData?.sector,
        personId: formData?.personId,
        consultant: formData?.consultant,
        regDate: formData?.regDate,
        source: formData?.source,
        statusDate: formData?.regDate,
        status: formData?.status,
        payrollNo: payrollNo.value,
        paymentDetails: {
          employmentType: "PAYE",
        },
        gdpr: [
          {
            qNo: 1,
            checked: true,
            consentOn: new Date(),
          },
          {
            qNo: 2,
            checked: true,
            consentOn: new Date(),
          },
          {
            qNo: 3,
            checked: true,
            consentOn: new Date(),
          },
          {
            qNo: 4,
            checked: true,
            consentOn: new Date(),
          },
        ],
      };
      if (accounts?.length > 0) {
        const accessToken = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        });
        payload.accessToken = accessToken.accessToken
      }
      dispatch(addCandidates(payload, setAddEmploye, props.token, resetForm));
    }
  };

  return (
    <>
      <Offcanvas
        show={addEmploye}
        onHide={() => {
          resetForm();
          setAddEmploye(false);
        }}
        className="offcanvas-end customeoff"
        placement="end"
      >
        <div className="offcanvas-header">
          <h5 className="modal-title" id="#gridSystemModal">
            {props.Title}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              resetForm();
              setAddEmploye(false);
            }}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div className="offcanvas-body">
          <div className="container-fluid">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {[
                  {
                    label: "Title",
                    field: "title",
                    type: "select",
                    required: true,
                    options: ["", "Mr.", "Mrs.", "Ms."],
                  },
                  { label: "First Name", field: "firstName", required: true },
                  { label: "Last Name", field: "lastName", required: true },
                  { label: "Known As", field: "knownAs", required: false },
                  { label: "Post Code", field: "postCode", required: true },
                  // { label: "Home", field: "home", required: false },
                  {
                    label: "Address Line 1",
                    field: "addressLine1",
                    required: false,
                  },
                  { label: "Address Line 2", field: "addressLine2" },
                  { label: "Town", field: "town", required: true },
                  { label: "County", field: "county" },
                  { label: "Country", field: "country", required: true },
                  // { label: "Region", field: "region", required: false },
                  {
                    label: "Phone Type",
                    field: "phone",
                    type: "select",
                    options: ["", "Home", "Mobile"],
                    required: true,
                  },
                  {
                    label: "Phone Number",
                    field: "phoneNumber",
                    type: "number",
                    required: true,
                  },
                  {
                    label: "Email",
                    field: "email",
                    type: "email",
                    required: true,
                  },
                  // { label: "Office", field: "office", required: false },
                  // { label: "Sector", field: "sector", type: "select", required: false, options: ["", "Industrial"] },
                  { label: "Person ID", field: "personId", disabled: true },
                  {
                    label: "Source",
                    type: "select",
                    field: "source",
                    required: false,
                    options: ["", ...sourceList,],
                    // options: [
                    //   "",
                    //   "Client Referral",
                    //   "CV Library",
                    //   "Facebook",
                    //   "Indeed",
                    //   "Job Centre",
                    //   "LinkedIn",
                    //   "Referral",
                    // ],
                  },
                ].map(
                  ({
                    label,
                    field,
                    type = "text",
                    required = false,
                    disabled = false,
                    options = [],
                  }) => (
                    <div className="col-xl-6 mb-3" key={field}>
                      {type === "select" ? (
                        <>
                          <label className="form-label">
                            {label}{" "}
                            {required && <span className="text-danger">*</span>}
                          </label>
                          <select
                            name={field}
                            className="form-control"
                            value={formData[field]}
                            onChange={(e) =>
                              handleInputChange(field, e.target.value)
                            }
                          >
                            {options?.map((itm) => (
                              <option value={itm}>{itm}</option>
                            ))}
                          </select>
                        </>
                      ) : (
                        <>
                          <label className="form-label">
                            {label}{" "}
                            {required && <span className="text-danger">*</span>}
                          </label>
                          <input
                            type={type}
                            name={field}
                            className="form-control"
                            disabled={disabled}
                            value={formData[field]}
                            onChange={(e) =>
                              handleInputChange(field, e.target.value)
                            }
                          />
                          {field === "postCode" && results?.length > 0 && (
                            <div
                              style={{
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                                maxHeight: "150px", // Medium size scrollable div
                                overflowY: "auto",
                                marginTop: "5px",
                                padding: "10px",
                                backgroundColor: "#fff",
                              }}
                            >
                              {results?.map((suggestion, index) => (
                                <div
                                  key={index}
                                  data-testid={`postcode-suggestion-${index}`}
                                  tabIndex={0}
                                  style={{
                                    padding: "5px",
                                    cursor: "pointer",
                                    borderBottom: "1px solid #eee",
                                  }}
                                  onClick={() =>
                                    handleSuggestionClick(suggestion)
                                  } // Handle click on suggestion
                                >
                                  {suggestion.address}
                                </div>
                              ))}
                            </div>
                          )}
                        </>
                      )}
                      {errors[field] && (
                        <small className="text-danger">{errors[field]}</small>
                      )}
                    </div>
                  )
                )}
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Consultant</label>
                  <input
                    type="text"
                    disabled
                    className="form-control"
                    value={formData.consultant}
                  />
                </div>
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Registration Date</label>
                  <br />
                  <DatePicker
                    className="form-control"
                    selected={formData.regDate}
                    onChange={(date) => handleInputChange("regDate", date)}
                    dateFormat="dd/MM/yyyy"
                  />
                  {errors.regDate && (
                    <small className="text-danger">{errors.regDate}</small>
                  )}
                </div>
                {/* <div className="col-xl-6 mb-3">
                  <label className="form-label">Record Updated</label>
                  <br />
                  <DatePicker
                    className="form-control"
                    selected={formData.recordUpdated}
                    onChange={(date) =>
                      handleInputChange("recordUpdated", date)
                    }
                  />
                  {errors.recordUpdated && (
                    <small className="text-danger">
                      {errors.recordUpdated}
                    </small>
                  )}
                </div>
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Status Date</label>
                  <br />
                  <DatePicker
                    className="form-control"
                    selected={formData.statusDate}
                    onChange={(date) => handleInputChange("statusDate", date)}
                  />
                  {errors.statusDate && (
                    <small className="text-danger">{errors.statusDate}</small>
                  )}
                </div> */}
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Status</label>
                  <select
                    className="default-select form-control"
                    value={formData.status}
                    onChange={(e) =>
                      handleInputChange("status", e.target.value)
                    }
                  >
                    <option value="" ></option>
                    {
                      statusList.map((itm) => <option value={itm}>{itm}</option>)
                    }
                  </select>
                </div>
              </div>
              <div>
                <button type="submit" className="btn btn-primary me-1">
                  Submit
                </button>
                <Link
                  to={"#"}
                  onClick={() => {
                    resetForm();
                    setAddEmploye(false);
                  }}
                  className="btn btn-danger light ms-1"
                >
                  Cancel
                </Link>
              </div>
            </form>
          </div>
        </div>
      </Offcanvas>
    </>
  );
});

export default AddCandidate;
